'use strict';

var template    = require('../../templates/settings/PositionItem.ejs');
var RowEditView = require('commons/views/RowEdit');

module.exports = RowEditView.extend({
    tagName: 'tr',
    className: 'item',

    initialize: function(options) {
        var self = this;

        self.options = _.defaults(options || {}, {
            template:  template,
            deletable: true
        });

        return RowEditView.prototype.initialize.apply(self, [self.options]);
    },

    render: function() {
        var self = this;
        var r = RowEditView.prototype.render.apply(self, arguments);

        setTimeout(self.initializeControls.bind(self), 1);

        return r;
    },

    initializeControls: function() {
        var self = this;

        // The UI design has a weird placement for the delete button
        self.$('.form-control-with-delete').each(function(i, control) {
            var $control = self.$(control);
            var $value = $control.find('.form-control-value');
            var $input = $control.find('.form-control');

            $value.css({
                display: 'inline-block',
                maxWidth: (
                    $input.width() -
                    $control.find('.btn-delete').outerWidth(true) - 5
                ) + 'px'
            }).text($input.val());

            $value.on('click', function() {
                $control.addClass('focus');
                $input.focus();
            });

            $input.on('keyup', function(ev) {
                var val = self.$(ev.target).val();
                $value.text(val);
            })
            .on('focus', function() {
                $control.addClass('focus');
            })
            .on('blur', function() {
                $control.removeClass('focus');
            });
        });
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/PositionItem.js